import { render } from "./CPagination.vue?vue&type=template&id=3bfd1d73"
import script from "./CPagination.vue?vue&type=script&lang=js"
export * from "./CPagination.vue?vue&type=script&lang=js"

import exportComponent from "E:\\PhpstormProjects\\cinnet_panel\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__